import { useState } from "react";

export function FormField({ label, error, required, children, className = '' }) {
  return (
    <div className={className}>
      {label && (
        <label className="mb-1.5 block text-[11px] font-bold uppercase tracking-[0.08em] text-slate-500">
          {label}
          {required && <span className="text-[#1a3366]"> *</span>}
        </label>
      )}
      {children}
      {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
    </div>
  )
}

const inputClass = (error, className = "") =>
  `w-full rounded-lg border px-3 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[#1a3366]/15 focus:border-[#1a3366] h-10 box-border ${
    error ? "border-red-300 bg-red-50/30" : "border-slate-200 bg-[#f4f7fb]"
  } ${className}`;

export function TextInput({ className = '', error, placeholder, ...props }) {
  return (
    <input
      className={inputClass(error, className)}
      placeholder={placeholder}
      {...props}
    />
  );
}

export function SelectInput({
  children,
  className = "",
  error,
  value,
  onChange,
  ...props
}) {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative w-full">
      <select
        value={value}
        onChange={onChange}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        className={`${inputClass(error, className)} appearance-none pr-10`}
        {...props}
      >
        {children}
      </select>
      <div className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 text-xs">
        {open ? "▲" : "▼"}
      </div>
    </div>
  );
}

export function TextArea({ className = '', rows = 3, error, ...props }) {
  return (
    <textarea
      rows={rows}
      className={inputClass(error, className)}
      {...props}
    />
  )
}

export function FieldBox({ label, required, children }) {
  return (
    <div className="field-box">
      <div className="field-box-label">
        {label}
        {required ? <span> *</span> : null}
      </div>
      <div className="field-box-value">{children || "—"}</div>
    </div>
  );
}
